import { render, staticRenderFns } from "./SaitenInput.vue?vue&type=template&id=aff9e77c&scoped=true&"
import script from "./SaitenInput.vue?vue&type=script&lang=ts&"
export * from "./SaitenInput.vue?vue&type=script&lang=ts&"
import style0 from "./SaitenInput.vue?vue&type=style&index=0&id=aff9e77c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff9e77c",
  null
  
)

export default component.exports